// extracted by mini-css-extract-plugin
export default {"capitalize":"completed-view_capitalize__XwLCT","lowercase":"completed-view_lowercase__rHc4m"};